<template>
  <div class="collection-detail">
    <div class="history-wrapper">
      <el-date-picker
        v-model="historyDate"
        type="month"
        placeholder="选择月"
        @blur="historyDateBlur"
      >
      </el-date-picker>
    </div>
    <el-tabs type="card">
      <el-tab-pane label="基础数据">
        <div class="basic-tab">
          <el-form :inline="true" label-width="150px" style="margin-top: 16px;">
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="项目部">
                  <el-input
                    :value="detailData.projectDeptName"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="项目名称">
                  <el-input :value="detailData.projectName" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="欠款单位">
                  <el-input :value="detailData.debtName" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="审计及竣工情况">
                  <el-input
                    :value="detailData.processStatusDisplayName"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="监理名称">
                  <el-input
                    :value="detailData.supervisorName"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="审计完结日期">
                  <el-input
                    :value="detailData.auditFinishTime"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="合同签订日期">
                  <el-input :value="detailData.signDate" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="合同工期">
                  <el-input :value="detailData.projectTime" readonly>
                    <!-- <template slot="append">天</template> -->
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="缺陷责任期限">
                  <el-input :value="detailData.liabilityPeriod" readonly>
                    <!-- <template slot="append">天</template> -->
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="开工日期(开工令)">
                  <el-input :value="detailData.startTime" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="合同金额">
                  <el-input
                    :value="formatMoneyNumber(detailData.contractPrice)"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="税率">
                  <el-input
                    :value="Number(detailData.taxRate || 0).toFixed(2)"
                    readonly
                  >
                    <template slot="append">%</template></el-input
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="不含税合同金额">
                  <el-input
                    :value="formatMoneyNumber(detailData.notTaxContractPrice)"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="审计金额">
                  <el-input
                    :value="formatMoneyNumber(detailData.auditPrice)"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="交工日期">
                  <el-input :value="detailData.deliveTime" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="竣工日期">
                  <el-input :value="detailData.finishTime" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div
            class="table-wrapper"
            v-show="detailData.itemVOList && detailData.itemVOList.length > 0"
          >
          <el-table :data="detailData.itemVOList" border style="width: 100%">
            <el-table-column label="期数" prop="number" width="150" fixed></el-table-column>
            <el-table-column label="完成产值" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.finishPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="计量金额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.calculatePrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="申请日期" prop="applyTime" width="200">
            </el-table-column>
            <el-table-column label="批复金额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.replyPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="批复时间" prop="replyTime" width="200"></el-table-column>
            <el-table-column label="开具发票金额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.billPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="销项税金额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.outputTaxPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="收款金额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.receiptPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="完成产值占合同比例" width="100">
              <template slot-scope="scope">
                <div>{{formatPercentNumber(scope.row.finishPriceRate)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="计量金额占合同比例" width="100">
              <template slot-scope="scope">
                <div>{{formatPercentNumber(scope.row.calculatePriceRate)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="已批复产值占合同比例" width="100">
              <template slot-scope="scope">
                <div>{{formatPercentNumber(scope.row.replyPriceRate)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="已收款占合同额比例" width="100">
              <template slot-scope="scope">
                <div>{{formatPercentNumber(scope.row.receiptPriceRate)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="应收账款" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.receiptPlanPrice)}}</div>
              </template>
            </el-table-column>
          </el-table>
          </div>
          <div>
            <p>应收账款明细分析</p>
            <el-form label-width="150px" style="margin-top: 16px;">
              <el-form-item label="质保金">
                <el-input
                  :value="formatMoneyNumber(detailData.qaPrice)"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item
                label="需交工验收、审计、竣工验收后应支付工程款(不含质保金）"
                class="long-label"
              >
                <el-input
                  :value="formatMoneyNumber(detailData.lastProjectPrice)"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item
                label="按进度应支付工程款（欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款）"
                class="long-label"
              >
                <el-input
                  :value="formatMoneyNumber(detailData.processProjectPrice)"
                  readonly
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <p>按账龄划分金额</p>
            <el-form label-width="150px" style="margin-top: 16px;">
              <el-form-item label="1年以内">
                <el-input
                  :value="formatMoneyNumber(detailData.oneYearPrice)"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item label="1-2年">
                <el-input
                  :value="formatMoneyNumber(detailData.oneToTwoYearPrice)"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item label="2-3年">
                <el-input
                  :value="formatMoneyNumber(detailData.twoToThreeYearPrice)"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item label="3年（含）以上">
                <el-input
                  :value="formatMoneyNumber(detailData.threeYearPrice)"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item label="内容（应返还时间）">
                <el-input :value="detailData.yearContent" readonly></el-input>
              </el-form-item>
              <el-form-item
                label="应收账款未返还原因及工作推进情况"
                class="long-label"
              >
                <el-input
                  :value="detailData.notReasonAndProcess"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item label="责任人">
                <el-input
                  :value="detailData.responseUserName"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item label="预计回收时间">
                <el-input
                  :value="detailData.estimateReceiptTime"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item label="回收比例">
                <el-input
                  :value="Number(detailData.takeBackRate || 0).toFixed(2)"
                  readonly
                >
                  <template slot="append">%</template></el-input
                >
              </el-form-item>
            </el-form>
          </div>
          <div class="basic-footer">
            <p>最近操作用户：{{ detailData.operateUserName }}</p>
            <p>最近操作日期：{{ detailData.operateTime }}</p>
          </div>
        </div>
        <div style="text-align: center;padding-bottom: 20px;">
          <el-button @click="closePage" type="info">关闭</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="项目部计量台账" style="padding: 16px;">
        <h1 style="text-align: center;">项目部计量台账</h1>
        <p>
          <span style="width: 80px;">项目部：</span>
          {{ detailData.projectDeptName }}
        </p>
        <p>
          <span style="width: 80px;">项目名称：</span>
          {{ detailData.projectName }}
        </p>
        <p>单位:元</p>
        <div class="table-wrapper">
          <el-table :data="detailData.itemVOList" border show-summary style="width: 100%;" :summary-method="getSummaries" :span-method="arraySpanMethod">
            <el-table-column label="期数" prop="number" width="100" fixed></el-table-column>
            <el-table-column label="合同金额" width="200">
              <template>
                <div>{{formatMoneyNumber(detailData.contractPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="完成产值" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.finishPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="计量金额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.calculatePrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="申请日期" prop="applyTime" width="200"></el-table-column>
            <el-table-column label="批复金额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.replyPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="批复时间" prop="replyTime" width="200"></el-table-column>
            <el-table-column label="开具发票金额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.billPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="销项税金额" width="200">
               <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.outputTaxPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="收款金额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.receiptPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="完成产值占合同比例" width="200">
              <template slot-scope="scope">
                <div>{{formatPercentNumber(scope.row.finishPriceRate)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="计量金额占合同比例" width="200">
              <template slot-scope="scope">
                <div>{{formatPercentNumber(scope.row.calculatePriceRate)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="已批复产值占合同比例" width="200">
              <template slot-scope="scope">
                <div>{{formatPercentNumber(scope.row.replyPriceRate)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="已收款占合同额比例" width="200">
               <template slot-scope="scope">
                <div>{{formatPercentNumber(scope.row.receiptPriceRate)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="应收账款" width="200">
               <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.receiptPlanPrice)}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center;margin-top: 16px;">
          <el-button type="primary" @click="exportTabpane2">导出</el-button>
          <el-button @click="closePage" type="info">关闭</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="应收账款" style="padding: 16px;">
        <h1 style="text-align: center;">应收账款明细表</h1>
        <p>单位:元</p>
        <div class="table-wrapper">
          <!-- 这里做个假的数据。是因为表格就直接绑定detailData的数据，并不是绑定个数组。 -->
          <!-- 也可以自建个数组，里面就detailData一个数据，这样就可以当成普通的el-table来做 -->
          <el-table border style="width:100%" :data="detailData && detailData.projectDeptName ? [1] : []">
            <el-table-column label="项目部" width="200" fixed>
              <template>
                <div>{{detailData.projectDeptName}}</div>
              </template>
            </el-table-column>
            <el-table-column label="项目名称" width="200" fixed>
              <template>
                <div>{{detailData.projectName}}</div>
              </template>
            </el-table-column>
            <el-table-column label="欠款单位" width="200">
              <template>
                <div>{{detailData.debtName}}</div>
              </template>
            </el-table-column>
            <el-table-column label="审计及竣工情况" width="200">
              <template>
                <div>{{detailData.processStatusDisplayName}}</div>
              </template>
            </el-table-column>
            <el-table-column label="审计额或已完成产值" width="200">
              <template>
                <div>{{formatMoneyNumber(detailData.auditOrFinishPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="已收款" width="200">
              <template>
                <div>{{formatMoneyNumber(detailData.receiptPriceSum)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="欠款总金额（业主所欠全部工程款）" width="200">
              <template>
                <div>{{formatMoneyNumber(detailData.debtPrice)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="欠款金额明细分析">
              <el-table-column label="质保金" width="200">
                <template>
                  <div>{{formatMoneyNumber(detailData.qaPrice)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="需交工验收、审计、竣工验收后应支付工程款(不含质保金）" width="200">
                <template>
                  <div>{{formatMoneyNumber(detailData.lastProjectPrice)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="按进度应支付工程款（欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款）" width="200">
                <template>
                  <div>{{formatMoneyNumber(detailData.processProjectPrice)}}</div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="按账龄划分金额">
              <el-table-column label="1年以内" width="100">
                <template>
                  <div>{{formatMoneyNumber(detailData.oneYearPrice)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="1-2年" width="100">
                <template>
                  <div>{{formatMoneyNumber(detailData.oneToTwoYearPrice)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="2-3年" width="100">
                <template>
                  <div>{{formatMoneyNumber(detailData.twoToThreeYearPrice)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="3年（含）以上" width="100">
                <template>
                  <div>{{formatMoneyNumber(detailData.threeYearPrice)}}</div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="内容（应返还时间）" width="200">
              <template>
                  <div>{{detailData.yearContent}}</div>
                </template>
            </el-table-column>
            <el-table-column label="欠款未返回原因及工作推进情况" width="200">
              <template>
                  <div>{{detailData.notReasonAndProcess}}</div>
                </template>
            </el-table-column>
            <el-table-column label="责任人" width="200">
              <template>
                  <div>{{detailData.responseUserName}}</div>
                </template>
            </el-table-column>
            <el-table-column label="预计回收时间" width="200">
              <template>
                  <div>{{detailData.estimateReceiptTime}}</div>
                </template>
            </el-table-column>
            <el-table-column label="回收比例" width="200">
              <template>
                  <div>{{formatPercentNumber(detailData.takeBackRate)}}</div>
                </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center;margin-top: 16px;">
          <el-button type="primary" @click="exportTabpane3">导出</el-button>
          <el-button @click="closePage" type="info">关闭</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/**
 * 收款记录详情
 */
import Constants from "../../utils/consts";
import {
  getCollectionDetail,
  receiptsExportApi,
  getCollectionHistoryDetail,
} from "../../services/financeService";
import { formatMoney, formatPercent } from "./utils";
export default {
  data() {
    return {
      id: undefined,
      projectId: undefined,
      detailData: {},
      historyDate: "",
    };
  },
  methods: {
    arraySpanMethod({row,column,rowIndex,columnIndex}) {
      if(columnIndex == 1) {
        if(this.detailData && this.detailData.itemVOList) {
          if(rowIndex == 0) {
            return {
              rowspan: this.detailData.itemVOList.length,
              colspan: 1
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      }
    },
    getSummaries(params) {
      // console.log('--getSummaries', params);
      // const { columns, data } = params;
      const sums = [];
      if(this.detailData) {
        sums[0] = "合计";
        sums[2] = this.formatMoneyNumber(this.detailData.finishPriceSum); //累计完成产值
        sums[3] = this.formatMoneyNumber(this.detailData.calculatePriceSum); //累计计量金额
        sums[5] = this.formatMoneyNumber(this.detailData.replyPriceSum); //累计批复金额
        sums[7] = this.formatMoneyNumber(this.detailData.billPriceSum);//累计开票金额
        sums[9] = this.formatMoneyNumber(this.detailData.receiptPriceSum); //累计收款金额
      }
      
      return sums;
    },
    formatMoneyNumber: formatMoney,
    formatPercentNumber: formatPercent,
    onActive() {
      let params = this.tabRouteParam || {};
      if (params.id) {
        this.id = params.id;
        this.projectId = params.projectId;
        this.historyDate = params.historyDate;
      }
      if(params.monthDate) {
        this.historyDate = new Date(params.monthDate);
      } else {
        this.historyDate = new Date();
      }
      
      if (!this.id || !this.projectId) {
        return;
      }
      
      this.getHistoryDetail();
    },
    // getDetail() {
    //   // 这一进来的详情接口，这个接口只是当前的记录的，历史记录用另一个接口，虽然数据结构完全一致
    //   getCollectionDetail({ receiptsId: this.id })
    //     .then(res => {
    //       if (Constants.Code_OK == res.code) {
    //         this.detailData = res.data;
    //       } else {
    //         this.$alert(res.msg, "提示");
    //       }
    //     })
    //     .catch(error => {
    //       this.$alert(error instanceof Error ? error.message : error, "提示");
    //     });
    // },
    getHistoryDetail() {
      getCollectionHistoryDetail({
        monthDate: this.formatDate(this.historyDate),
        projectId: this.projectId,
      })
        .then((res) => {
          if (Constants.Code_OK == res.code) {
            this.detailData = res.data;
          } else {
            /**
             * 那整个项目都存在这个问题
             * 先正常进入页面，获取数据，显示出来
             * 然后点侧边栏回列表页，选择其他项查看详情
             * 会再次回到本页面，但是并不是重新进入，页面并没有重新走生命周期，所以数据和显示仍然在
             * 此时新选择的项调用接口报错，看到的就是之前的数据了。
             */
            this.detailData = {};
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.detailData = {};
          console.log("没有数据", this.detailData);
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    exportTabpane2() {
      //:导出项目部计量台账
      if (!this.id) {
        this.$alert("操作失败", "提示");
        return;
      }
      receiptsExportApi({
        exportTypes: ["book"],
        receiptsIds: [this.id],
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            console.log("=======", res.data);
            let url = res.data;
            const a = document.createElement("a");
            a.href = url;
            a.download = "项目部计量台账";
            a.click();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert("操作失败", "提示");
        });
    },
    exportTabpane3() {
      //:导出应收账款明细表
      if (!this.id) {
        this.$alert("操作失败", "提示");
        return;
      }
      receiptsExportApi({
        exportTypes: ["receiptsSum"],
        receiptsIds: [this.id],
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            console.log("=======", res.data);
            let url = res.data;
            const a = document.createElement("a");
            a.href = url;
            a.download = "应收账款明细表";
            a.click();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert("操作失败", "提示");
        });
    },
    historyDateBlur() {
      console.log("blur", this.historyDate);
      console.log(this.historyDate instanceof Date);
      if (this.historyDate) {
        this.getHistoryDetail();
      }
      // 如果blur之后没值，就当他没想好要看哪个月的，就还看之前的
    },
    formatDate(date) {
      if (date) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        return year + "-" + (month < 10 ? "0" + month : month);
      }
      return "";
    },
    closePage() {
      this.bus.$emit("tabClose", "collectionDetail");
      this.bus.$emit("navMenuChange", {
        routeId: "collectionList"
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";

.collection-detail {
  background: white;
  position: relative;
}
.history-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
  padding-top: 2px;
  padding-right: 10px;
}

/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
/deep/.el-tabs__item:hover {
  color: #069dbc;
}

/deep/.el-form-item {
  width: 100%;
}
/deep/.el-form-item__content {
  width: calc(100% - 150px);
}

.basic-tab {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 40px;
}

.basic-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/deep/.long-label {
  .el-form-item__label {
    line-height: 24px !important;
  }
}

.table-wrapper {
  margin-bottom: 16px;
}
</style>
